export const IS_FABRIC = "nativeFabricUIManager" in global;
